"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageModal = void 0;
const React = require("react");
const dialogs_1 = require("../../../../types/dialogs");
const Modal_1 = require("../../structure/Modal");
const Caption_1 = require("../Caption");
const Img_1 = require("../Img");
const ImageModal = ({ src, alt, onClose }) => {
    return (React.createElement(Modal_1.Modal, { onClose: onClose, open: !!src, size: dialogs_1.TDialogSizes.Medium },
        React.createElement(Modal_1.ModalHeader, null, "\u00A0"),
        React.createElement(Modal_1.ModalBody, null,
            !!src && React.createElement(Img_1.Img, { fullwidth: true, src: src }),
            !!alt && React.createElement(Caption_1.Caption, { title: alt }))));
};
exports.ImageModal = ImageModal;
//# sourceMappingURL=index.js.map